/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Blog_Reading_OtherInputs */

const en_blog_reading_other = /** @type {(inputs: Blog_Reading_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min read`)
};

const lv_blog_reading_other = /** @type {(inputs: Blog_Reading_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min lasīšanas`)
};

/**
* | output |
* | --- |
* | "{count} min read" |
*
* @param {Blog_Reading_OtherInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_reading_other = /** @type {((inputs: Blog_Reading_OtherInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Reading_OtherInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_reading_other(inputs)
	return en_blog_reading_other(inputs)
});